
import { cropUrl } from '@/utils/images'
import {
  firstUnseenIndex,
  hasStoryToAnnounce,
  instagramStories,
  openingToSend,
  readClickedStories,
  readSeenStories,
  rememberSeen,
  rememberStoriesOpening,
  writeClickedStories,
  writeSeenStories,
} from '@/utils/instagramStories'
import { isExcludedVisitor } from '@/utils/sitePresence'
import { isStaffTraffic } from '@/utils/staffTraffic'

export default {
  name: 'HeaderInstagramStories',
  components: {
    InstagramStoriesViewer: () =>
      import('@/components/InstagramStoriesViewer.vue'),
  },
  data() {
    return {
      stories: [],
      loading: true,
      seenIds: [],
      clickedIds: [],
      viewerOpen: false,
      startIndex: 0,
      brokenPreviews: [],
    }
  },
  computed: {
    nextIndex() {
      return firstUnseenIndex(this.stories, this.seenIds)
    },
    preview() {
      const image = this.stories[this.nextIndex]?.image
      const sources = image
        ? [cropUrl(image, this.size * 2, this.size * 2, 'jpg'), image.url]
        : []
      return (
        [...sources, '/icon.png'].find(
          source => !this.brokenPreviews.includes(source)
        ) || '/icon.png'
      )
    },
    announce() {
      return hasStoryToAnnounce(this.stories, this.seenIds, this.clickedIds)
    },
    size() {
      return this.$device.isMobile ? 36 : 34
    },
  },
  async mounted() {
    this.seenIds = readSeenStories()
    this.clickedIds = readClickedStories()
    try {
      const { data } = await this.$instagramStoriesService.fetch()
      this.stories = instagramStories(data)
    } catch {
      this.stories = []
    } finally {
      this.loading = false
    }
    if (this.stories.length) {
      this.track('impression')
    }
  },
  methods: {
    open() {
      this.clickedIds = this.stories.map(story => story.id)
      writeClickedStories(this.clickedIds)
      this.startIndex = this.nextIndex
      this.viewerOpen = true
      this.track('open')
      this.rememberOpening()
    },
    excluded() {
      return isExcludedVisitor({
        staff: isStaffTraffic(this.$auth),
        adminLoggedInUser: this.$nuxtCookies?.get?.('admin_logged_in_user'),
      })
    },
    track(event) {
      if (this.excluded()) return
      this.$instagramStoriesService
        .track({ event, touch_screen: navigator.maxTouchPoints > 1 })
        .catch(() => {})
    },
    rememberOpening() {
      if (this.excluded()) return
      const cart = this.$store.state.cart
      const opening = openingToSend(rememberStoriesOpening(), cart)
      if (opening) {
        this.$orderService
          .setInstagramStoriesOpened(cart.id, { opened_at: opening })
          .catch(() => {})
      }
    },
    markSeen(id) {
      this.seenIds = rememberSeen(this.seenIds, id, this.stories)
      writeSeenStories(this.seenIds)
    },
  },
}
